import { IDeleteCargoUseCase } from "../../../presentation/useCases/delete/delete_cargo_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * DeleteCargoUseCase
 */

export class DeleteCargoUseCase implements IDeleteCargoUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async deleteCargo(
    idCargo: number,
  ): Promise<void> {
    await this.repository.deleteCargo(idCargo);
  }
}
